package org.hs_soft.runmynesto.domain.model.general_error_model


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Extensions(
    @SerialName("code")
    val code: String?=null,
    @SerialName("invalidArgs")
    val invalidArgs: List<String?>?=null,
    @SerialName("serviceName")
    val serviceName: String?=null,
)